var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var lang = UpAct.lang;

__p+='\n<div class="box box-'+
((__t=(boxIndex))==null?'':__t)+
'">\n	<div class="btn-gr">\n		';

			var linkNum = lang.template(prefix+"_BUTTON&DOWNLOADLINK")*1;
			for(var i=0;i<linkNum;i++){
				var allowPhoneDownload = lang.template(prefix+"_DOWNLOAD_PHONE_ALLOW"+(i+1)) === 'yes' ? true : false;
				var link = lang.template(prefix+'_DOWNLOADLINK'+(i+1));
				var title = lang.template(prefix+'_DOWNLOADBUTTON'+(i+1));
				var isObs = lang.template(prefix+"_DOWNLOAD"+(i+1)+"_IS_OBS") === 'yes' ? true : false;
		
__p+='\n			<a href="'+
((__t=(link))==null?'':__t)+
'" data-src="'+
((__t=(link))==null?'':__t)+
'" data-allow="'+
((__t=(allowPhoneDownload))==null?'':__t)+
'" data-is-obs="'+
((__t=(isObs))==null?'':__t)+
'">'+
((__t=(title))==null?'':__t)+
'</a>\n		';

			}
		
__p+='\n	</div>\n	';
 for(var i=0;i<5;i++){ 
__p+='\n		';
 
			var title = prefix+"_TITLE"+(i+1);
			if(lang.template(title) !== title){ 
		
__p+='\n			<div class="title">'+
((__t=(lang.template(title)))==null?'':__t)+
'</div>\n		';
 }else{ break; } 
__p+='\n		';

			for(var j=0;j<15;j++){
		
__p+='\n			';
 
				var step = title+"_STEP"+(j+1);
				if(lang.template(step) !== step){
			
__p+='\n			<div class="block block-'+
((__t=(i+'-'+j))==null?'':__t)+
'">\n				<div class="title">'+
((__t=(lang.template(step)))==null?'':__t)+
'</div>\n				<div class="block-content">\n					';

						for(var k=0;k<5;k++){
						var picture = step+"_PICTURE"+(k+1);
						var txt = step+"_TEXT"+(k+1);
					
__p+='\n\n						';
 if(lang.template(txt) !== txt){ 
__p+='\n							<div class="txt">'+
((__t=(lang.template(txt)))==null?'':__t)+
'</div>\n						';
 } 
__p+='\n						';
 if(lang.template(picture) !== picture){ 
__p+='\n							<div class="img"><img data-src="'+
((__t=(lang.template(picture)))==null?'':__t)+
'" width="110"/></div>\n						';
 } 
__p+='\n					';
 } 
__p+='\n				</div>\n			</div>\n			';
 }else{ break; } 
__p+='\n		';

			}
		
__p+='\n	';
 } 
__p+='\n</div>\n';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/template/block.tmpl
// module id = 28
// module chunks = 0